import React from "react";
import { Link } from "react-router-dom";
import Newsletter from "@/components/Newsletter";
import { useT } from "@/i18n/useT";

export default function Footer() {
  const t = useT();
  const f = t.footer;
  return (
    <footer data-testid="footer" className="bg-espresso text-cream mt-32">
      <div className="border-t border-cream/20" />
      <div className="br-container py-20 grid grid-cols-1 md:grid-cols-3 gap-16">
        <div>
          <div className="font-serif text-2xl mb-4">BalticRoots</div>
          <p className="text-sm font-light leading-relaxed text-cream/70 max-w-xs">{f.tagline}</p>
        </div>
        <div className="grid grid-cols-2 gap-8">
          <div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-amber mb-4">{f.discover}</div>
            <ul className="space-y-3 text-sm font-light">
              <li><Link to="/shop" className="hover:text-amber transition-colors">{f.shop}</Link></li>
              <li><Link to="/story" className="hover:text-amber transition-colors">{f.ourStory}</Link></li>
              <li><Link to="/latvia" className="hover:text-amber transition-colors">{f.latvia}</Link></li>
              <li><Link to="/journal" className="hover:text-amber transition-colors">{f.journal}</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-amber mb-4">{f.care}</div>
            <ul className="space-y-3 text-sm font-light">
              <li><Link to="/contact" className="hover:text-amber transition-colors">{f.contact}</Link></li>
              <li><Link to="/shipping" className="hover:text-amber transition-colors">{f.shipping}</Link></li>
              <li><Link to="/faq" className="hover:text-amber transition-colors">{f.faq}</Link></li>
              <li><Link to="/privacy" className="hover:text-amber transition-colors">{f.privacy}</Link></li>
            </ul>
          </div>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-amber mb-4">{f.storiesFromLatvia}</div>
          <Newsletter inverse />
        </div>
      </div>
      <div className="border-t border-cream/10">
        <div className="br-container py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="text-[11px] tracking-[0.2em] uppercase text-cream/50">© {new Date().getFullYear()} BalticRoots · {f.madeIn}</div>
          <div className="text-[11px] tracking-[0.2em] uppercase text-cream/50">Riga · Latvia · EU</div>
        </div>
      </div>
    </footer>
  );
}